"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKpiWidgetDefinition = exports.isKpiWidget = exports.isInsightWidgetDefinition = exports.isInsightWidget = exports.widgetTitle = exports.widgetType = exports.widgetRef = exports.widgetUri = exports.widgetId = exports.isWidget = exports.isWidgetDefinition = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidgetDefinition}.
 * @deprecated Use {@link @gooddata/sdk-model#isWidgetDefinition}
 * @alpha
 */
exports.isWidgetDefinition = m.isWidgetDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidget}.
 * @deprecated Use {@link @gooddata/sdk-model#isWidget}
 * @alpha
 */
exports.isWidget = m.isWidget;
/**
 * Gets the widget identifier
 *
 * @param widget - widget to get identifier of
 * @returns the widget identifier
 * @deprecated Use {@link @gooddata/sdk-model#widgetId}
 * @alpha
 */
exports.widgetId = m.widgetId;
/**
 * Gets the widget uri
 *
 * @param widget - widget to get uri of
 * @returns the widget uri
 * @deprecated Use {@link @gooddata/sdk-model#widgetUri}
 * @alpha
 */
exports.widgetUri = m.widgetUri;
/**
 * Gets the widget ref
 *
 * @param widget - widget to get ref of
 * @returns the widget ref
 * @deprecated Use {@link @gooddata/sdk-model#widgetRef}
 * @alpha
 */
exports.widgetRef = m.widgetRef;
/**
 * Gets the widget type
 *
 * @param widget - widget to get type of
 * @returns the widget type
 * @deprecated Use {@link @gooddata/sdk-model#widgetType}
 * @alpha
 */
exports.widgetType = m.widgetType;
/**
 * Gets the widget title
 *
 * @param widget - widget to get title of
 * @returns the widget title
 * @deprecated Use {@link @gooddata/sdk-model#widgetTitle}
 * @alpha
 */
exports.widgetTitle = m.widgetTitle;
/**
 * Type-guard testing whether the provided object is an instance of {@link IInsightWidget}.
 * @deprecated Use {@link @gooddata/sdk-model#isInsightWidget}
 * @alpha
 */
exports.isInsightWidget = m.isInsightWidget;
/**
 * Type-guard testing whether the provided object is an instance of {@link IInsightWidgetDefinition}.
 * @deprecated Use {@link @gooddata/sdk-model#isInsightWidgetDefinition}
 * @alpha
 */
exports.isInsightWidgetDefinition = m.isInsightWidgetDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IKpiWidget}.
 * @deprecated Use {@link @gooddata/sdk-model#isKpiWidget}
 * @alpha
 */
exports.isKpiWidget = m.isKpiWidget;
/**
 * Type-guard testing whether the provided object is an instance of {@link IKpiWidget}.
 * @deprecated Use {@link @gooddata/sdk-model#isKpiWidgetDefinition}
 * @alpha
 */
exports.isKpiWidgetDefinition = m.isKpiWidgetDefinition;
//# sourceMappingURL=widget.js.map